module.exports = __webpack_public_path__ + "img/ctrl-qft-stub-up-+i.1de62bb2.svg";